exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-info-container[data-v-1230b931] {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.part-description[data-v-1230b931] {\n  position: relative;\n  z-index: 1;\n  color: #fff;\n  margin: 0 0 10px;\n}", ""]);

// exports
